import React from 'react';
import Header from './Header';
import MobileNav from './MobileNav';
import CategorySidebar from '../CategorySidebar';
import PromotionsSidebar from '../PromotionsSidebar';

interface LayoutProps {
  children: React.ReactNode;
  showSidebar?: boolean;
  showCategorySidebar?: boolean;
  showPromotionsSidebar?: boolean;
  containerSize?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

const Layout: React.FC<LayoutProps> = ({
  children,
  showCategorySidebar = true,
  showPromotionsSidebar = true,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
        background: 'var(--pw-bg-soft)',
      }}
    >
      {/* Header */}
      <div style={{ flexShrink: 0 }}>
        <Header />
      </div>

      {/* Three-column body */}
      <div style={{ flex: 1, display: 'flex', overflow: 'hidden', minHeight: 0 }}>

        {/* Left column: categories & filters */}
        {showCategorySidebar && (
          <aside
            className="d-none d-lg-block"
            style={{
              width: 260,
              flexShrink: 0,
              overflowY: 'auto',
              overflowX: 'hidden',
              borderRight: '1px solid var(--pw-border)',
              background: 'var(--pw-surface)',
            }}
          >
            <CategorySidebar />
          </aside>
        )}

        {/* Middle column: scrollable content */}
        <main
          style={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            minWidth: 0,
            background: 'var(--pw-bg-soft)',
          }}
        >
          {/* Desktop */}
          <div className="d-none d-lg-block p-4">
            {children}
          </div>
          {/* Mobile */}
          <div className="d-lg-none p-3" style={{ paddingBottom: 80 }}>
            {children}
          </div>
        </main>

        {/* Right column: promotions */}
        {showPromotionsSidebar && (
          <aside
            className="d-none d-xl-block"
            style={{
              width: 280,
              flexShrink: 0,
              overflow: 'hidden',
              height: '100%',
              borderLeft: '1px solid var(--pw-border)',
              background: 'var(--pw-surface)',
            }}
          >
            <PromotionsSidebar />
          </aside>
        )}
      </div>

      {/* Mobile bottom navigation */}
      <MobileNav />
    </div>
  );
};

export default Layout;
